<template>
  <div>
    <ResourceDetail
      v-if="pageStatus === 'resourceDetail'"
      @changeToLeader="changeToLeader()"
    ></ResourceDetail>
    <ResourceLeader
      v-if="pageStatus === 'leader'"
      @changeToDetail="changeToDetail"
    ></ResourceLeader>
  </div>
</template>
<script>
import ResourceDetail from "./resourceDetail/ResourceDetail";
import ResourceLeader from "./resourceLeader/ResourceLeader";
export default {
  name: "Right",
  components: {
    ResourceDetail,
    ResourceLeader,
  },
  data() {
    return {
      pageStatus: "leader",
    };
  },
  methods: {
    changeToLeader() {
      this.pageStatus = "leader";
    },
    changeToDetail(val) {
      console.log(val)
      this.pageStatus = "resourceDetail";
      
    },
  },
};
</script>

<style>
</style>